import { Doc, generateToDocFn } from '@dadohr/shared/domainTypes/document';
import { WorkdayIntegrationConfig } from '@dadohr/shared/domainTypes/integrations/workday';
import { FS } from '@dadohr/shared/versions';
import shortid from 'shortid';
import {
  store,
  useMappedLoadingValue
} from '../../../../../../services/firebase';
import {
  createDocumentListenerGetter,
  useDocumentListener
} from '../../../../../../services/firecache/documentListener';
import { now } from '../../../../../../services/time';

export const toWorkdayConfigDoc = generateToDocFn<WorkdayIntegrationConfig>(
  (d) => {
    d.endpoints = d.endpoints || [];
    return d;
  }
);

const COLLECTION = FS.workdayIntegrationConfig;
const collection = () => store().collection(COLLECTION);
export const workdayConfigStore = createDocumentListenerGetter(
  (orgId) => collection().doc(orgId),
  toWorkdayConfigDoc
);

export const useWorkdayConfig = (orgId: string, userId: string) => {
  return useMappedLoadingValue(
    useDocumentListener(workdayConfigStore(orgId)),
    (d) => {
      if (!d) {
        const n = now();
        const newConfig: Doc<WorkdayIntegrationConfig> = {
          id: orgId,
          collection: COLLECTION,
          data: {
            orgId,
            active: false,
            createdAt: n,
            createdBy: userId,
            editedAt: n,
            editedBy: userId,

            importApiUrl: '',
            username: '',
            password: '',
            endpoints: [
              {
                id: shortid(),
                name: '',
                url: '',
                username: '',
                password: ''
              }
            ]
          }
        };
        return newConfig;
      }
      return d;
    }
  );
};

export const removeWorkdayConfig = (orgId: string) => {
  return collection().doc(orgId).delete();
};
